import { useState, useEffect, useContext } from 'react';
import { Link, Navigate, Outlet, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { AppContext } from './context'
import Login from "./login"
import Home from './home';
import Subscription from './subsciption';
import BrandAuth from './brand_auth';
import BrandAuthView from './brand_auth_view';
import Account from './account';
import AccountChangePassword from './account_change_password';
import UiSpinner from './ui_spinner';
import NavbarSidebar from './navbar_sidebar';
import AgencyInfo from './agency_info';
import { useAuth0 } from '@auth0/auth0-react';
import ChangeEmail from './change_email';
import NotFound from './not_found';
import EditorBrand from './editor_brand';
import EditorBrandProduct from './editor_brand_product';
import Impersonate from './impersonate';
import BrandGoals from './brand_goals';
import Authentication from './authentication';
import Kiosk from './kiosk';
import AccountMfa from './account_mfa';
import BrandPage from './brand_page';
import UsersPage from './user_page';

const Navbar = () => {

    const navigate = useNavigate()
    let location = useLocation()
    let [width, setWidth] = useState(0)
    let { token, neonUser, hh, ww, offCanvas, path, setPath, setPopupSidebarType } = useContext(AppContext)
    let { isAuthenticated, isLoading } = useAuth0()

    const getWidth = () => {
        let h = window.innerWidth
        setWidth(h)
    }

    const showLeftSidebar = () => {
	
        setPopupSidebarType("sidebar")
        offCanvas.show()
    }

    useEffect(() => {
        setPath(location.pathname)
        if (offCanvas) offCanvas.hide()
    }, [location])

    useEffect(() => {
        if (!("agency_int_id" in neonUser) && isAuthenticated && ["owner"].includes(neonUser.role)) {
            navigate("/agency_info")
            return
        }
        if (neonUser.user_id && !neonUser["asked_subscription?"] && ["owner"].includes(neonUser.role)) {
            navigate("/subscription")
            return
        }
    }, [neonUser, isAuthenticated])

    useEffect(() => {
        getWidth()
        window.addEventListener("resize", getWidth)
        return () => window.removeEventListener("resize", getWidth)
    }, [])

    if (path == "/agency_info") return (<AgencyInfo />)
    if (path == "/subscription") return (<Subscription register={true} />)
    if (path == "/authenticate") return (<Authentication />)
    if (path == "/kiosk") return (<Kiosk />)

    return (
        <div>
            {isAuthenticated ?
                <div className="d-flex">
                    <div hidden={ww < 800} style={{ width: 250 }}>
                        <NavbarSidebar />
                    </div>

                    <div style={{ width: width - (ww < 800 ? 0 : 250) }}>
                        <div style={{ height: 80 }} className={"bg-white w-100 " + (ww < 400 ? 'px-2' : 'px-4')}>
                            <div className="d-flex justify-content-between h-100">
                                <div className="d-flex gap-2">
                                    <i style={{cursor: "pointer"}} onClick={showLeftSidebar} hidden={ww >= 800} className="bi bi-list align-self-center fs-1"></i>
                                    <p className="poppins align-self-center mb-0"></p>
                                </div>
                                <div className="d-flex justify-content-between gap-3 align-self-center">
                                    <Link to="/account" style={{ textDecoration: "none" }} className="poppins mb-0 text-dark">
                                        <div className="d-flex gap-1 justify-content-between">
                                            <span className="align-self-center">Account</span>
                                            <i className="bi bi-chevron-down align-self-center" style={{ width: 15 }}></i>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                        </div>

                        <div style={{ height: `calc(${hh}px - 80px)`, overflowY: "auto" }} id="viewEl">
                            {token ?
                                <div>
                                    {neonUser['active?'] == true ?
                                        <>
                                            <Routes>
                                                <Route path="/" element={<Home />} />

                                                <Route path="/account" element={["owner"].includes(neonUser.role) ? <Account /> : <AccountChangePassword />} />
                                                <Route path="/account/change-pass" element={<AccountChangePassword />} />
                                                <Route path="/account/mfa" element={<AccountMfa />} />
                                                <Route path='/account/change_email/:uuid' element={<ChangeEmail />} />
                                                <Route path='/account/change_email/:uuid/confirm/:confirm_uuid' element={<ChangeEmail />} />

                                                {["owner", "admin"].includes(neonUser.role) &&
                                                    <>
                                                        <Route path="/brand/products/:id" element={<EditorBrandProduct />} />
                                                        <Route path="/brand/goals/:id" element={<BrandGoals />} />
                                                    </>
                                                }
                                                {neonUser && neonUser.role == "owner" &&
                                                    <>
                                                        <Route path="/brand/auth/:id" element={<BrandAuth />} />
                                                        <Route path="/brand/auth/view/:id" element={<BrandAuthView />} />
                                                        <Route path="/brand" element={<BrandPage />} />
                                                        <Route path="/brand/id/:id" element={<BrandPage />} />
                                                        <Route path="/account/subscription" element={<Subscription register={false} />} />
                                                        <Route path="/subscription" element={<Subscription />} />
                                                        <Route path='/agency_info' element={<AgencyInfo />} />
                                                        <Route path="/users" element={<UsersPage />} />
                                                    </>
                                                }
                                                {neonUser && neonUser.role == "admin" &&
                                                    <>
                                                        <Route path="/brand" element={<BrandPage isAdmin={true} />} />
                                                        <Route path="/brand/auth/:id" element={<BrandAuth />} />
                                                        <Route path="/brand/auth/view/:id" element={<BrandAuthView />} />
                                                        <Route path="/users" element={<UsersPage />} />
                                                    </>
                                                }
                                                {neonUser && neonUser.role == "editor" &&
                                                    <>
                                                        <Route path="/brand" element={<EditorBrand />} />
                                                        <Route path="/brand/:id" element={<EditorBrandProduct />} />
                                                    </>
                                                }
                                                {neonUser && neonUser.role == "dev" &&
                                                    <>
                                                        <Route path="/impersonate" element={<Impersonate />} />
                                                    </>
                                                }

                                                <Route path='*' exact={true} element={<NotFound />} />
                                            </Routes>
                                            <Outlet />
                                        </>
                                        :
                                        neonUser['active?'] == undefined ?
                                            <div className="d-flex justify-content-center" style={{ height: hh }}>
                                                <UiSpinner />
                                            </div>
                                            :
                                            <NotFound revoked={true} />
                                    }
                                </div>
                                :
                                null
                            }
                        </div>
                    </div>
                </div>
                :
                <Login />
            }
        </div>
    )
}

export default Navbar